var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 11.1V6.9C17.4 3.91766 14.9823 1.5 12 1.5V1.5C9.01764 1.5 6.59998 3.91766 6.59998 6.9V11.1",
    stroke: "#172664",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 10.5C19.1462 10.5 20.3996 11.6818 20.3998 13.1396V21.0596C20.3998 22.5176 19.1464 23.7002 17.6 23.7002H6.39978C4.85347 23.7001 3.59998 22.5175 3.59998 21.0596V13.1396C3.60018 11.6818 4.8536 10.5001 6.39978 10.5H17.6ZM11.1 15.9004V20.7002H12.8998V15.9004H11.1Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLocked);
export default __webpack_public_path__ + "static/media/btn_Locked.e2911de80aa52ae832fc0abc69c3b23d.svg";
export { ForwardRef as ReactComponent };